import React, { useContext } from "react";

import { EventTags } from "@features/offer/shared/event";
import { EventContext, OfferOptionsContext } from "@gp/components";
import { EventOffer } from "@gp/offer";

import { EventFullInfoHeaderActions } from "./EventFullInfoHeaderActions";
import { EventFullInfoSelector } from "./EventFullInfoSelector";

export function EventFullInfoHeader() {
	const event = useContext(EventContext) as EventOffer;
	const offerOptionsContext = useContext(OfferOptionsContext);

	return (
		<div className="event__match">
			<div className="event__content">
				{/* @ts-expect-error */}
				{!(offerOptionsContext.isHistoryEvent?.(event.id) ?? false) && (
					<div className="event__top">
						<EventTags event={event} />
						<EventFullInfoHeaderActions />
					</div>
				)}

				<EventFullInfoSelector event={event} />
			</div>
		</div>
	);
}
